import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { setQuickDonatePopStateAction } from "redux/actions/QuickDonatePopActions/setQuickDonatePopStateActions";
import { quickDonateActions } from "redux/actions/QuickDonate/quickDonateActions";

interface QuickDonateProps {}

const QuickDonate = ({}: QuickDonateProps) => {
  const { t, i18n } = useTranslation();
  const dispatch: any = useDispatch();

  const [show, setShow] = useState(false);
  const pageHeight = document.documentElement.scrollHeight;

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setShow(true);
      } else {
        setShow(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      {show && (
        <div
          onClick={() => {
            dispatch(setQuickDonatePopStateAction(true));
            dispatch(quickDonateActions());
          }}
          className={`fixed bottom-[8%] right-[8%] z-10 w-[90px] h-[90px] bg-white font-${
            i18n.language === "en" ? "Poppins" : "Almarai"
          } font-[600] text-[15px] text-first_color border-[5px] rounded-full border-first_color flex flex-col items-center justify-center cursor-pointer animate-pulse hover:scale-125 duration-500`}
        >
          {i18n.language === "en" ? (
            <>
              <p>{t("Quick")}</p> <p>{t("Donate")}</p>
            </>
          ) : (
            <>
              <p>{t("Donate")}</p> <p>{t("Quick")}</p>
            </>
          )}
        </div>
      )}
    </>
  );
};

export default QuickDonate;
